import { Module } from 'vuex';

import { actions } from '@/store/modules/auth/actions';
import { getters } from '@/store/modules/auth/getters';
import { mutations } from '@/store/modules/auth/mutations';
import { state } from '@/store/modules/auth/state';
import { AuthState } from '@/store/modules/auth/types';
import { RootState } from '@/store/types';

export const auth: Module<AuthState, RootState> = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
